import { combineReducers } from "redux";

import AuthReducer from "../components/Authentication/modules/reducer";
import UsersReducer from "../components/Users/modules/reducer";
import InsuranceReducer from "../components/Insurance/modules/reducer";
import InsuranceOfferRequestReducer from "../components/InsuranceHome/OfferRequests/modules/reducer";
import OfferRequestReducer from "../components/OfferRequests/modules/reducer";
import InsuranceRequestDetailsReducer from "../components/InsuranceHome/RequestDetails/modules/reducer";
import OrdersReducer from "../components/InsuranceHome/Orders/modules/reducer";
import OfferResponseReducer from "../components/OfferResponses/modules/reducer";

export default combineReducers({
  authReducer: AuthReducer,
  usersReducer: UsersReducer,
  insuranceReducer: InsuranceReducer,
  insuranceOfferRequestReducer: InsuranceOfferRequestReducer,
  offerRequestReducer: OfferRequestReducer,
  insuranceRequestDetailsReducer: InsuranceRequestDetailsReducer,
  ordersReducer: OrdersReducer,
  offerResponseReducer: OfferResponseReducer,
});
